defineDs('DanskeSpil/Domain/RetailAccount/Scripts/Templates/Pages/ConfirmCallback', [
  'DanskeSpil/Domain/RetailAccount/Scripts/Templates/Loader',
], function (Loader) {

  var ConfirmCallback = function (controller) {
    return Loader({ loaderText: controller.d('RestrictCloseAccountLoaderText') });
  };

  return ConfirmCallback;
});